import { createAction } from 'redux-actions';
import { push } from 'react-router-redux';
import { openGlobalModal } from 'actions/modal';
import { toggleLoading } from 'actions/global';

import { wrapFetch, wrapFetchAuth } from './endpoint';

export const getShopList = createAction('GET_SHOP_LIST', () => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetch('api/web/shop', {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			shop: data,
		};
	}
	return {};
});

export const getShopInfo = createAction('GET_SHOP_INFO', id => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth(`api/web/shop/${id}`, {
		method: 'GET',
	});

	dispatch(toggleLoading(false));
	if (status === 200) {
		return {
			shopInfo: data,
			shopTime: data.times,
		};
	}
	return {};
});

export const getReservationList = createAction('GET_RESERVATION_LIST', () => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth('api/web/reservationForm', {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		return {
			list: data.reservation_forms,
			count: data.reservation_count,
		};
	}
	return {
	};
});

export const checkReservationCount = createAction('CHECK_RESERVATION_COUNT', () => async dispatch => {
	const { status, data } = await wrapFetchAuth('api/web/reservationForm', {
		method: 'GET',
	});

	if (status === 200) {
		if (data.reservation_count >= 3) {
			dispatch(push('/reserve'));
			dispatch(openGlobalModal('reserveFullCount'));
		}
	}
});

export const addReservation = createAction('ADD_RESERVATION', (id, remarks) => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth('api/web/reservationForm', {
		method: 'POST',
		body: JSON.stringify({ shop_time_id: id, remarks }),
	});
	dispatch(toggleLoading(false));
	if (status === 200 || status === 201) {
		console.log(data);
		dispatch(getReservationList());
		dispatch(push('/reserve'));
	}
});

export const getReservation = createAction('GET_RESERVATION', id => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, data } = await wrapFetchAuth(`api/web/reservationForm/${id}`, {
		method: 'GET',
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		dispatch(getShopInfo(data.shop_time.shop_id));
		return {
			reservationForm: {
				id,
				type: data.shop_time.type,
				remarks: data.remarks,
				name: data.shop_time.shop.name,
				date: data.shop_time.date,
				time: data.shop_time.time,
				timeId: data.shop_time.id,
			},
		};
	}
	return {};
});

export const reviseReservation = createAction('REVISE_RESERVATION', (id, timeId) => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, message } = await wrapFetchAuth(`api/web/reservationForm/${id}`, {
		method: 'PUT',
		body: JSON.stringify({ shop_time_id: timeId }),
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		dispatch(push('/reserve'));
		dispatch(getReservationList());
	} else if (message === 'can not change time.') {
		dispatch(openGlobalModal('reserveCanNotRevise'));
	}
});

export const cancelReservation = createAction('CANCEL_RESERVATION', id => async dispatch => {
	dispatch(toggleLoading(true));
	const { status, message } = await wrapFetchAuth(`api/web/reservationForm/${id}`, {
		method: 'PUT',
		body: JSON.stringify({ status: 'CANCEL' }),
	});
	dispatch(toggleLoading(false));

	if (status === 200) {
		dispatch(getReservationList());
	} else if (message === 'can not cancel.') {
		dispatch(openGlobalModal('reserveCanNotCancel'));
	}
});




// WEBPACK FOOTER //
// ./src/actions/reservation.js